/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { VerifiedIconCP } from '../../../../../../../images/icons/Verified/Verified'

export const AddressDetails = (props: any) => (
    <div>
        <div className={`addressBlock__content addressBlock__content--details`}>
            {/* <div className="addressBlock__addressType">{props.addressType}</div> */}
            <div className="addressBlock__details">
                <span>{props.addressLine1}</span>
                <span>{props.addressLine2}</span>
                <span>{props.city}</span>
                <span>{props.postcode}</span>
                {(props.countryName) ? <span>{props.countryName}</span> : ''}
                {(props.addressAllocated) ?
                    <span className="allocated">{(props.addressAllocated).toLocaleString('en-GB', {
                        style: 'currency',
                        currency: 'GBP',
                    })}</span> : null}
            </div>
            <hr />

            {props.securityVerified ? <VerifiedBadge /> : null}

            {(props.securityVerified && props.hideDeleteLocation) ? (<div />) : null}
        </div>
        <div className={`cp_address_btns ${!props.hideDeleteLocation ? 'two_btns' : ''}`}>
            {(!props.securityVerified) ? (
                <div className="addressBlock__verify" onClick={props.triggerVerify} >
                    Use this address
                </div>
            ) : (
                <div className="addressBlock__verify" onClick={props.triggerVerify}>
                    Edit Property
                </div>
            )}

            {!props.hideDeleteLocation && (
                <div
                    className="addressBlock__verify addressBlock__verify--delete"
                    onClick={() => props.triggerDelete(props.temp_id)}
                >
                    Remove address
                </div>
            )}
        </div>
    </div>
)

/**
 * Verified Badge
 */
const VerifiedBadge = () => (
    <div className="addressBlock__verified">
        <VerifiedIconCP />
    </div>
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/Step02cp/components/AddressDetails.tsx